"use strict";
/*
 * Created on 25. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Approval status converter.
 *
 * @author Radek Beran
 */


var PriceZoneStatsConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PriceZoneStatsConverter, _DataObjectConverter_);

  function PriceZoneStatsConverter() {
    _classCallCheck(this, PriceZoneStatsConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceZoneStatsConverter).apply(this, arguments));
  }

  return PriceZoneStatsConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PriceZoneStatsConverter = PriceZoneStatsConverter;